import { Component, Input } from '@angular/core';
import { CloseModalDirective } from '../../directives/modal.close.directive';

@Component({
  selector: 'app-congratulation-popup',
  imports: [CloseModalDirective],
  templateUrl: './congratulation-popup.component.html',
  styleUrl: './congratulation-popup.component.scss'
})
export class CongratulationPopupComponent {

  @Input() toastMsg: any;
  @Input() showToastSuccess: any;

  handler__close() {
    this.toastMsg = "";
    this.showToastSuccess = false;
  }

}
